import React,{Component} from 'react';
import './DocumentsPage.css';

import { documentsBanner, logo } from '../../_utils/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../_utils/routes';
import Footer from '../../components/Footer/Footer';

interface Props{
}
interface State{
}

export default class DocumentsPage extends Component<Props, State> {

    render(){
        return (
        <Page 
            id="documents"
            title="Documents"
            footer={<Footer/>}
            banner={{
                bannerImage: documentsBanner,
                topBar:{
                    routes: routes,
                    logo: logo,
                }
            }}
        >
            <div className="page-content">
                <div className="centered-content padding">
                    <div className="title-3">Quisque hendrerit</div>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi non ultricies nisl, non elementum nisi. Pellentesque ut enim eu neque 
                        consectetur aliquet. Etiam vehicula aliquam libero, ut dictum sapien feugiat at. Duis nec ornare dui. Nullam tellus odio, elementum 
                        vitae placerat ut, sodales ornare libero. Nam iaculis sem vitae quam rutrum pharetra. Pellentesque nec interdum justo. Donec congue 
                        ullamcorper ultrices. Quisque ultrices pretium mi eget commodo. In dictum nisl non quam tempus vehicula. Nulla non ex vestibulum, 
                        aliquet est nec, sollicitudin augue. Aenean nec metus luctus quam tempus tincidunt. Pellentesque ut nibh ex. Praesent sodales mauris 
                        in ex volutpat bibendum.
                        <br/>
                        <br/>
                        Nam consequat, magna at feugiat tempor, magna nulla posuere mauris, sed placerat quam erat ut elit. Morbi sed lorem id dolor pharetra 
                        convallis quis quis metus. Quisque hendrerit, odio nec tincidunt sollicitudin, ante ante dapibus tellus, ac sagittis diam augue eget massa. 
                        Vestibulum quis purus sed nibh aliquet rutrum. In hac habitasse platea dictumst. Ut a mauris volutpat, cursus ligula eu, dapibus est. Nunc 
                        sit amet bibendum sem. Donec sodales massa in nunc vestibulum sodales sit amet euismod orci. Suspendisse vitae volutpat arcu.
                    </p>
                    <br/>
                    <br/>
                    <div className="title-3">Class aptent</div>
                    <p>
                        Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget lorem volutpat, venenatis ante id, 
                        commodo orci. Pellentesque consequat orci in risus euismod auctor. Nam at tincidunt enim, nec faucibus nisl. Duis ullamcorper turpis et 
                        purus vehicula sagittis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec nisi dolor, 
                        congue a luctus ac, ornare laoreet elit. Vivamus eu aliquam nisl, non faucibus urna. Interdum et malesuada fames ac ante ipsum primis in 
                        faucibus. Quisque a ultricies nisi, porttitor consectetur diam. Nunc placerat iaculis diam non facilisis. Quisque ut justo non magna 
                        blandit vehicula sit amet ut nibh. Pellentesque laoreet et turpis eget tempus. In arcu sapien, sollicitudin ac urna sit amet, dapibus 
                        sollicitudin erat.
                    </p>

                </div>
            </div>
        </Page>
        );
    }


};